// "use client";
// import { useState, useEffect } from "react";
// import { Menu, X, Code } from "lucide-react";

// export const Navbar = () => {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [isScrolled, setIsScrolled] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => {
//       setIsScrolled(window.scrollY > 10);
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   const navLinks = [
//     { label: "Home", href: "#" },
//     { label: "About", href: "#about" },
//     { label: "Services", href: "#services" },
//     { label: "Portfolio", href: "#portfolio" },
//   ];

//   return (
//     <nav className={`sticky top-0 z-50 transition-all duration-500 ${isScrolled
//         ? "bg-white/90 backdrop-blur-md shadow-lg py-2"
//         : "bg-transparent py-4"
//       }`}>
//       <div className="max-w-7xl mx-auto px-6 flex justify-between items-center">
//         {/* Logo */}
//         <a href="#" className="flex items-center gap-2 group">
//           <div className="p-2 bg-gradient-to-r from-blue-600 to-emerald-500 rounded-lg group-hover:scale-110 transition-transform duration-300">
//             <Code className="w-5 h-5 text-white" />
//           </div>
//           <div className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-blue-600 to-emerald-500 bg-clip-text text-transparent tracking-tight">
//             Momin<span className="font-extralight">Hussain</span>
//           </div>
//         </a>

//         {/* Nav + Button (combined) */}
//         <div className="hidden md:flex items-center gap-6">
//           <ul className="flex space-x-1 text-[16px] font-medium">
//             {navLinks.map((item, idx) => (
//               <li key={idx} className="relative group">
//                 <a
//                   href={item.href}
//                   className="relative text-gray-700 transition-all duration-300 px-3 py-2 rounded-lg group hover:text-blue-600"
//                 >
//                   {item.label}
//                   {/* Sliding gradient underline */}
//                   <span className="absolute left-0 -bottom-1 h-0.5 w-0 bg-gradient-to-r from-blue-600 to-emerald-500 transition-all duration-500 group-hover:w-full"></span>
//                   {/* Bounce/scale effect */}
//                   <span className="absolute inset-0 scale-95 group-hover:scale-105 transition-transform duration-300"></span>
//                 </a>

//               </li>
//             ))}
//           </ul>

//           {/* Contact Button */}
//           <a
//             href="#contact"
//             className="relative px-5 py-2.5 text-white font-medium group overflow-hidden rounded-lg"
//           >
//             <span className="absolute inset-0 w-full h-full bg-gradient-to-r from-blue-600 to-emerald-500 transition-all duration-300 group-hover:from-blue-700 group-hover:to-emerald-600"></span>
//             <span className="absolute inset-0 w-full h-full bg-gradient-to-r from-blue-600 to-emerald-500 opacity-0 group-hover:opacity-100 blur-md transition-opacity duration-300"></span>
//             <span className="relative z-10 flex items-center gap-1">
//               Contact
//               <svg className="w-4 h-4 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
//               </svg>
//             </span>
//           </a>
//         </div>

//         {/* Mobile Menu Toggle */}
//         <div className="flex items-center gap-4 md:hidden">
//           <button
//             className="text-gray-800 focus:outline-none p-2 rounded-lg hover:bg-gray-100"
//             onClick={() => setMenuOpen(!menuOpen)}
//             aria-label="Toggle menu"
//           >
//             {menuOpen ? <X size={28} /> : <Menu size={28} />}
//           </button>
//         </div>
//       </div>

//       {/* Mobile Nav */}
//       <div
//         className={`md:hidden transition-all duration-500 ease-in-out ${menuOpen
//             ? "max-h-[500px] opacity-100 py-4 bg-white/95 backdrop-blur-md"
//             : "max-h-0 opacity-0 overflow-hidden"
//           }`}
//       >
//         <ul className="space-y-3 text-lg font-medium px-6">
//           {navLinks.map((item, idx) => (
//             <li key={idx}>
//               <a
//                 href={item.href}
//                 onClick={() => setMenuOpen(false)}
//                 className="block py-3 text-gray-800 hover:text-blue-600 transition duration-300 rounded-lg px-4 hover:bg-gray-100"
//               >
//                 {item.label}
//               </a>
//             </li>
//           ))}
//           <li className="pt-2">
//             <a
//               href="#contact"
//               onClick={() => setMenuOpen(false)}
//               className="block text-center bg-gradient-to-r from-blue-600 to-emerald-500 text-white px-5 py-3 rounded-lg transition duration-300 font-medium"
//             >
//               Contact Now
//             </a>
//           </li>
//         </ul>
//       </div>
//     </nav>
//   );
// };

// "use client";
// import { useState, useEffect } from "react";
// import { Menu, X, Code, ChevronDown, Sparkles, Cpu, Rocket } from "lucide-react";

// export const Navbar = () => {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [isScrolled, setIsScrolled] = useState(false);
//   const [activeLink, setActiveLink] = useState("#");
//   const [hoveredLink, setHoveredLink] = useState(null);
//   const [showNavbar, setShowNavbar] = useState(true);

//   // useEffect(() => {
//   //   const handleScroll = () => {
//   //     setIsScrolled(window.scrollY > 10);

//   //     // Update active link based on scroll position
//   //     const sections = navLinks.map(link => link.href.replace('#', ''));
//   //     for (const section of sections) {
//   //       if (section) {
//   //         const element = document.getElementById(section);
//   //         if (element) {
//   //           const rect = element.getBoundingClientRect();
//   //           if (rect.top <= 100 && rect.bottom >= 100) {
//   //             setActiveLink(`#${section}`);
//   //             break;
//   //           }
//   //         }
//   //       }
//   //     }
//   //   };

//   //   window.addEventListener("scroll", handleScroll);
//   //   return () => window.removeEventListener("scroll", handleScroll);
//   // }, []);


//   useEffect(() => {
//     let lastScrollY = window.scrollY;

//     const handleScroll = () => {
//       const currentScrollY = window.scrollY;

//       // Navbar hide/show
//       if (currentScrollY > lastScrollY && currentScrollY > 100) {
//         setShowNavbar(false); // scrolling down
//       } else {
//         setShowNavbar(true); // scrolling up
//       }

//       lastScrollY = currentScrollY;

//       setIsScrolled(currentScrollY > 10);

//       // Active section
//       const sections = navLinks.map((link) =>
//         link.href.replace("#", "")
//       );

//       for (const section of sections) {
//         if (section) {
//           const element = document.getElementById(section);

//           if (element) {
//             const rect = element.getBoundingClientRect();

//             if (rect.top <= 100 && rect.bottom >= 100) {
//               setActiveLink(`#${section}`);
//               break;
//             }
//           }
//         }
//       }
//     };

//     window.addEventListener("scroll", handleScroll);

//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//     };
//   }, []);

//   const navLinks = [
//     { label: "Home", href: "#", icon: <Sparkles className="w-4 h-4" /> },
//     { label: "About", href: "#about", icon: <Cpu className="w-4 h-4" /> },
//     { label: "Services", href: "#services", icon: <Rocket className="w-4 h-4" /> },
//     { label: "Portfolio", href: "#portfolio", icon: <Code className="w-4 h-4" /> },
//     // { label: "Blog", href: "#blog", icon: <Sparkles className="w-4 h-4" /> },
//     // { label: "Contact", href: "#contact", icon: <ChevronDown className="w-4 h-4" /> }
//   ];

//   // const navLinks = [
//   //   { label: "Home", href: "#" },
//   //   { label: "About", href: "#about" },
//   //   { label: "Services", href: "#services" },
//   //   { label: "Portfolio", href: "#portfolio" },
//   // ];

//   // Services dropdown items
//   // const servicesDropdown = [
//   //   { label: "Web Development", href: "#web-dev" },
//   //   { label: "Mobile Apps", href: "#mobile-apps" },
//   //   { label: "Cloud Solutions", href: "#cloud" },
//   //   { label: "AI & Machine Learning", href: "#ai-ml" },
//   //   { label: "DevOps", href: "#devops" }
//   // ];

//   return (
//     <>
//       <nav

//         className={`fixed top-0 left-0 right-0 z-50 transition-all duration-700 ease-in-out
//   ${showNavbar
//             ? "translate-y-0 opacity-100"
//             : "-translate-y-full opacity-0"
//           }
//   ${isScrolled
//             ? "bg-white/95 backdrop-blur-xl shadow-[0_8px_32px_rgba(0,0,0,0.08)] py-2 border-b border-gray-100/50"
//             : "bg-transparent py-2"
//           }`}

//       // className={`fixed top-0 left-0 right-0 z-50 transition-all duration-700 ${isScrolled
//       //   ? "bg-white/95 backdrop-blur-xl shadow-[0_8px_32px_rgba(0,0,0,0.08)] py-2 border-b border-gray-100/50"
//       //   : "bg-transparent py-2"
//       //   }`}

//       >
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-6">
//           <div className="flex justify-between items-center">
//             {/* Logo with advanced animation */}
//             <a
//               href="#"
//               className="flex items-center gap-3 group relative"
//               onMouseEnter={() => setHoveredLink('logo')}
//               onMouseLeave={() => setHoveredLink(null)}
//             >
//               {/* Animated background glow */}
//               <div className={`absolute inset-0 bg-gradient-to-r from-blue-600/20 to-emerald-500/20 blur-xl rounded-full transition-opacity duration-500 ${hoveredLink === 'logo' ? 'opacity-100 scale-150' : 'opacity-0'
//                 }`} />

//               {/* Logo icon with rotating animation */}
//               <div className="relative p-2.5 bg-gradient-to-r from-blue-600 to-emerald-500 rounded-xl group-hover:scale-110 transition-all duration-500 group-hover:rotate-3 group-hover:shadow-xl">
//                 <Code className="w-6 h-6 text-white animate-pulse" />
//                 {/* Floating particles */}
//                 <div className="absolute -top-1 -right-1 w-2 h-2 bg-yellow-400 rounded-full animate-ping" />
//                 <div className="absolute -bottom-1 -left-1 w-2 h-2 bg-emerald-400 rounded-full animate-ping delay-300" />
//               </div>

//               {/* Logo text with gradient animation */}
//               <div className="relative">
//                 <span className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-blue-600 via-emerald-500 to-blue-600 bg-[length:200%_auto] animate-gradient bg-clip-text text-transparent tracking-tight">
//                   Momin<span className="font-extralight">Hussain</span>
//                 </span>
//                 <span className="absolute -bottom-1 left-0 w-full h-0.5 bg-gradient-to-r from-blue-600 to-emerald-500 scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" />
//               </div>

//               {/* Company tagline on hover */}
//               <div className="absolute -bottom-8 left-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-xs font-medium text-gray-600 whitespace-nowrap">
//                 Software Development Company
//               </div>
//             </a>

//             {/* Desktop Navigation */}
//             <div className="hidden md:flex items-center gap-8">
//               <ul className="flex items-center space-x-1">
//                 {navLinks.map((item, idx) => (
//                   <li key={idx} className="relative group">
//                     <a
//                       href={item.href}
//                       className={`relative px-4 py-2.5 text-sm font-medium rounded-xl transition-all duration-300 flex items-center gap-2 ${activeLink === item.href
//                         ? "text-blue-600 bg-blue-50/50"
//                         : "text-gray-700 hover:text-blue-600"
//                         }`}
//                       onMouseEnter={() => setHoveredLink(item.label)}
//                       onMouseLeave={() => setHoveredLink(null)}
//                     >
//                       {/* Icon with animation */}
//                       <span className={`transition-transform duration-300 ${hoveredLink === item.label ? 'scale-110 rotate-3' : ''
//                         }`}>
//                         {item.icon}
//                       </span>

//                       {item.label}

//                       {/* Active indicator */}
//                       {activeLink === item.href && (
//                         <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-1 h-1 bg-gradient-to-r from-blue-600 to-emerald-500 rounded-full" />
//                       )}

//                       {/* Hover effect with gradient background */}
//                       <span className="absolute inset-0 bg-gradient-to-r from-blue-600/5 to-emerald-500/5 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

//                       {/* Sliding gradient underline */}
//                       <span className="absolute left-1/2 -bottom-1 -translate-x-1/2 h-0.5 w-0 bg-gradient-to-r from-blue-600 to-emerald-500 transition-all duration-500 group-hover:w-1/2" />
//                     </a>

//                     {/* Dropdown menu for Services */}
//                     {item.label === "Services" && (
//                       <div className="absolute top-full left-0 mt-2 w-64 bg-white/95 backdrop-blur-xl rounded-2xl shadow-xl border border-gray-100 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 transform origin-top-left scale-95 group-hover:scale-100">
//                         {/* <div className="py-2">
//                           {servicesDropdown.map((service, serviceIdx) => (
//                             <a
//                               key={serviceIdx}
//                               href={service.href}
//                               className="block px-4 py-3 text-sm text-gray-700 hover:bg-gradient-to-r hover:from-blue-50 hover:to-emerald-50 hover:text-blue-600 transition-all duration-300 group/item"
//                             >
//                               <span className="flex items-center gap-2">
//                                 <span className="w-1 h-1 bg-gradient-to-r from-blue-600 to-emerald-500 rounded-full opacity-0 group-hover/item:opacity-100 transition-opacity" />
//                                 {service.label}
//                                 <ChevronDown className="w-3 h-3 ml-auto opacity-0 group-hover/item:opacity-100 transition-all transform -rotate-90" />
//                               </span>
//                             </a>
//                           ))}
//                         </div> */}
//                       </div>
//                     )}
//                   </li>
//                 ))}
//               </ul>

//               {/* CTA Button with advanced animation */}
//               <div className="relative group">
//                 {/* Animated background rings */}
//                 <div className="absolute -inset-1 bg-gradient-to-r from-blue-600 to-emerald-500 rounded-xl opacity-20 group-hover:opacity-30 blur-lg transition-opacity duration-500 animate-pulse" />
//                 <div className="absolute -inset-0.5 bg-gradient-to-r from-blue-600 to-emerald-500 rounded-lg opacity-0 group-hover:opacity-100 blur transition-opacity duration-500" />

//                 <a
//                   href="#contact"
//                   className="relative px-6 py-3 bg-gradient-to-r from-blue-600 to-emerald-500 text-white font-medium rounded-lg overflow-hidden group flex items-center gap-2"
//                 >
//                   {/* Shine effect */}
//                   <span className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/30 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000" />

//                   {/* Button content */}
//                   <span className="relative z-10 flex items-center gap-2">
//                     Get Started
//                     <Rocket className="w-4 h-4 group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300" />
//                   </span>

//                   {/* Particle effects */}
//                   <span className="absolute top-1 left-1 w-1 h-1 bg-white rounded-full opacity-0 group-hover:opacity-100 animate-ping" />
//                   <span className="absolute bottom-1 right-1 w-1 h-1 bg-white rounded-full opacity-0 group-hover:opacity-100 animate-ping delay-300" />
//                 </a>
//               </div>
//             </div>

//             {/* Mobile Menu Toggle with animation */}
//             <div className="flex items-center gap-4 md:hidden">
//               <button
//                 className="relative p-2 text-gray-800 focus:outline-none rounded-xl hover:bg-gray-100 transition-all duration-300 group"
//                 onClick={() => setMenuOpen(!menuOpen)}
//                 aria-label="Toggle menu"
//               >
//                 <div className={`transition-all duration-500 ${menuOpen ? 'rotate-180 scale-110' : ''}`}>
//                   {menuOpen ? <X size={24} /> : <Menu size={24} />}
//                 </div>
//                 {/* Ripple effect */}
//                 <span className="absolute inset-0 rounded-xl bg-gradient-to-r from-blue-600/20 to-emerald-500/20 scale-0 group-hover:scale-100 transition-transform duration-500" />
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Mobile Menu with advanced animation */}
//         <div
//           className={`md:hidden transition-all duration-500 ease-in-out overflow-hidden ${menuOpen ? 'max-h-[600px] opacity-100 mt-4' : 'max-h-0 opacity-0'
//             }`}
//         >
//           <div className="bg-white/95 backdrop-blur-xl border-t border-gray-100 shadow-xl">
//             <ul className="space-y-1 p-4">
//               {navLinks.map((item, idx) => (
//                 <li key={idx}>
//                   <a
//                     href={item.href}
//                     onClick={() => setMenuOpen(false)}
//                     className={`flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-300 group ${activeLink === item.href
//                       ? "bg-gradient-to-r from-blue-50 to-emerald-50 text-blue-600"
//                       : "text-gray-700 hover:bg-gray-50"
//                       }`}
//                   >
//                     <span className={`transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3 ${activeLink === item.href ? 'text-blue-600' : 'text-gray-500'
//                       }`}>
//                       {item.icon}
//                     </span>
//                     <span className="flex-1 font-medium">{item.label}</span>
//                     <ChevronDown className={`w-4 h-4 transition-transform group-hover:translate-x-1 ${activeLink === item.href ? 'text-blue-600' : 'text-gray-400'
//                       }`} />
//                   </a>

//                   {/* Services submenu for mobile */}
//                   {/* {item.label === "Services" && (
//                     // <div className="ml-8 mt-1 space-y-1 border-l-2 border-gray-100 pl-2">
//                     //   {servicesDropdown.map((service, serviceIdx) => (
//                     //     <a
//                     //       key={serviceIdx}
//                     //       href={service.href}
//                     //       onClick={() => setMenuOpen(false)}
//                     //       className="block px-4 py-2 text-sm text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-300"
//                     //     >
//                     //       {service.label}
//                     //     </a>
//                     //   ))}
//                     // </div>
//                   )} */}
//                 </li>
//               ))}

//               {/* Mobile CTA */}
//               <li className="pt-4">
//                 <a
//                   href="#contact"
//                   onClick={() => setMenuOpen(false)}
//                   className="relative block bg-gradient-to-r from-blue-600 to-emerald-500 text-white px-5 py-4 rounded-xl font-medium overflow-hidden group"
//                 >
//                   <span className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/30 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000" />
//                   <span className="relative z-10 flex items-center justify-center gap-2">
//                     Start Your Project
//                     <Rocket className="w-4 h-4 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
//                   </span>
//                 </a>
//               </li>
//             </ul>
//           </div>
//         </div>
//       </nav>

//       {/* Add padding to prevent content from hiding under fixed navbar */}
//       <div className="h-16" />

//       <style jsx>{`
//         @keyframes gradient {
//           0% { background-position: 0% 50%; }
//           50% { background-position: 100% 50%; }
//           100% { background-position: 0% 50%; }
//         }
//         .animate-gradient {
//           animation: gradient 3s ease infinite;
//         }
//       `}</style>
//     </>
//   );
// };


"use client";
import { useState, useEffect } from "react";
import {
  Menu,
  X,
  Code,
  ChevronDown,
  Sparkles,
  Cpu,
  Rocket,
} from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import clsx from "clsx";
import { twMerge } from "tailwind-merge";

// helper
const cn = (...args) => twMerge(clsx(args));

// Reusable neumorphic shadow tokens (Tailwind arbitrary)
const neu = {
  raised:
    "shadow-[8px_8px_16px_#b8bcc2,-8px_-8px_16px_#ffffff]",
  raisedSm:
    "shadow-[4px_4px_8px_#b8bcc2,-4px_-4px_8px_#ffffff]",
  pressed:
    "shadow-[inset_6px_6px_12px_#b8bcc2,inset_-6px_-6px_12px_#ffffff]",
  pressedSm:
    "shadow-[inset_3px_3px_6px_#b8bcc2,inset_-3px_-3px_6px_#ffffff]",
};

export const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeLink, setActiveLink] = useState("#");
  const [hoveredLink, setHoveredLink] = useState(null);
  const [showNavbar, setShowNavbar] = useState(true);

  const navLinks = [
    { label: "Home", href: "#", icon: <Sparkles className="w-4 h-4" /> },
    { label: "About", href: "#about", icon: <Cpu className="w-4 h-4" /> },
    { label: "Services", href: "#services", icon: <Rocket className="w-4 h-4" /> },
    { label: "Portfolio", href: "#portfolio", icon: <Code className="w-4 h-4" /> },
  ];

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setShowNavbar(false);
      } else {
        setShowNavbar(true);
      }
      lastScrollY = currentScrollY;
      setIsScrolled(currentScrollY > 10);

      const sections = navLinks.map((l) => l.href.replace("#", ""));
      for (const section of sections) {
        if (section) {
          const el = document.getElementById(section);
          if (el) {
            const rect = el.getBoundingClientRect();
            if (rect.top <= 100 && rect.bottom >= 100) {
              setActiveLink(`#${section}`);
              break;
            }
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <motion.nav
        initial={false}
        animate={{
          y: showNavbar ? 0 : -120,
          opacity: showNavbar ? 1 : 0,
        }}
        transition={{ type: "spring", stiffness: 260, damping: 30 }}
        className={cn(
          "fixed top-0 left-0 right-0 z-50 transition-all duration-500",
          isScrolled ? "py-3 bg-[#e0e5ec]" : "py-5 bg-[#e0e5ec]"
        )}
      >
        {/* soft top glow strip */}
        <div
          className={cn(
            "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8",
            "transition-all duration-500"
          )}
        >
          <div
            className={cn(
              "flex items-center justify-between rounded-3xl px-4 sm:px-6 py-3",
              "bg-[#e0e5ec] transition-all duration-500",
              isScrolled ? neu.raised : neu.raisedSm
            )}
          >
            {/* ---------- LOGO ---------- */}
            <a
              href="#"
              className="flex items-center gap-3 group relative select-none"
              onMouseEnter={() => setHoveredLink("logo")}
              onMouseLeave={() => setHoveredLink(null)}
            >
              {/* Extruded icon chip */}
              <div
                className={cn(
                  "relative w-12 h-12 flex items-center justify-center rounded-2xl",
                  "bg-[#e0e5ec] transition-all duration-500",
                  hoveredLink === "logo" ? neu.pressedSm : neu.raisedSm
                )}
              >
                {/* gradient ring */}
                <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-blue-500/10 to-emerald-500/10" />
                <Code
                  className={cn(
                    "w-6 h-6 relative z-10 transition-all duration-500",
                    "text-transparent bg-clip-text",
                    "bg-gradient-to-br from-blue-600 to-emerald-500"
                  )}
                  stroke="url(#logo-grad)"
                />
                {/* svg gradient def */}
                <svg width="0" height="0" className="absolute">
                  <defs>
                    <linearGradient id="logo-grad" x1="0" y1="0" x2="1" y2="1">
                      <stop offset="0%" stopColor="#2563eb" />
                      <stop offset="100%" stopColor="#10b981" />
                    </linearGradient>
                  </defs>
                </svg>

                {/* subtle pulse dot */}
                <span className="absolute -top-0.5 -right-0.5 w-2 h-2 rounded-full bg-emerald-400 animate-ping opacity-70" />
              </div>

              {/* Brand text */}
              <div className="relative">
                <span className="text-xl md:text-2xl font-bold bg-gradient-to-r from-blue-600 via-emerald-500 to-blue-600 bg-[length:200%_auto] animate-gradient bg-clip-text text-transparent tracking-tight">
                  Momin<span className="font-extralight">Hussain</span>
                </span>
                <span className="absolute -bottom-0.5 left-0 w-full h-[2px] rounded-full bg-gradient-to-r from-blue-600 to-emerald-500 scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" />
              </div>
            </a>

            {/* ---------- DESKTOP NAV ---------- */}
            <div className="hidden md:flex items-center gap-3">
              <ul className="flex items-center gap-1.5">
                {navLinks.map((item, idx) => {
                  const isActive = activeLink === item.href;
                  return (
                    <li key={idx}>
                      <a
                        href={item.href}
                        onMouseEnter={() => setHoveredLink(item.label)}
                        onMouseLeave={() => setHoveredLink(null)}
                        className={cn(
                          "relative flex items-center gap-2 px-4 py-2.5 rounded-xl",
                          "text-sm font-medium transition-all duration-300",
                          "bg-[#e0e5ec]",
                          isActive
                            ? cn("text-blue-600", neu.pressedSm)
                            : "text-gray-600 hover:text-blue-600",
                          !isActive && hoveredLink === item.label && neu.raisedSm
                        )}
                      >
                        <span
                          className={cn(
                            "transition-transform duration-300",
                            hoveredLink === item.label && "scale-110 rotate-3",
                            isActive ? "text-blue-600" : "text-emerald-500"
                          )}
                        >
                          {item.icon}
                        </span>
                        {item.label}
                        {isActive && (
                          <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-6 h-[3px] rounded-full bg-gradient-to-r from-blue-600 to-emerald-500" />
                        )}
                      </a>
                    </li>
                  );
                })}
              </ul>

              {/* CTA */}
              <a
                href="#contact"
                className={cn(
                  "relative ml-2 px-5 py-2.5 rounded-xl font-medium text-sm",
                  "bg-[#e0e5ec] text-gray-700",
                  "flex items-center gap-2 overflow-hidden",
                  "transition-all duration-300 group",
                  neu.raisedSm,
                  "hover:shadow-[inset_4px_4px_8px_#b8bcc2,inset_-4px_-4px_8px_#ffffff]"
                )}
              >
                {/* gradient overlay appears on hover */}
                <span className="absolute inset-0 rounded-xl bg-gradient-to-r from-blue-600 to-emerald-500 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <span className="relative z-10 flex items-center gap-2 group-hover:text-white transition-colors duration-300">
                  Get Started
                  <Rocket className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </span>
              </a>
            </div>

            {/* ---------- MOBILE TOGGLE ---------- */}
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle menu"
              className={cn(
                "md:hidden relative w-11 h-11 rounded-xl flex items-center justify-center",
                "bg-[#e0e5ec] text-gray-700 transition-all duration-300",
                menuOpen ? neu.pressedSm : neu.raisedSm
              )}
            >
              <div
                className={cn(
                  "transition-transform duration-500",
                  menuOpen ? "rotate-180 scale-110" : ""
                )}
              >
                {menuOpen ? <X size={22} /> : <Menu size={22} />}
              </div>
            </button>
          </div>

          {/* ---------- MOBILE MENU ---------- */}
          <AnimatePresence>
            {menuOpen && (
              <motion.div
                initial={{ opacity: 0, y: -10, height: 0 }}
                animate={{ opacity: 1, y: 0, height: "auto" }}
                exit={{ opacity: 0, y: -10, height: 0 }}
                transition={{ duration: 0.35, ease: "easeInOut" }}
                className="md:hidden overflow-hidden mt-4"
              >
                <div
                  className={cn(
                    "bg-[#e0e5ec] rounded-3xl p-3",
                    neu.pressed
                  )}
                >
                  <ul className="space-y-2">
                    {navLinks.map((item, idx) => {
                      const isActive = activeLink === item.href;
                      return (
                        <li key={idx}>
                          <a
                            href={item.href}
                            onClick={() => setMenuOpen(false)}
                            className={cn(
                              "flex items-center gap-3 px-4 py-3 rounded-2xl",
                              "transition-all duration-300 bg-[#e0e5ec]",
                              isActive
                                ? cn("text-blue-600", neu.pressedSm)
                                : cn("text-gray-700", neu.raisedSm)
                            )}
                          >
                            <span
                              className={cn(
                                "transition-transform duration-300 group-hover:scale-110",
                                isActive ? "text-blue-600" : "text-emerald-500"
                              )}
                            >
                              {item.icon}
                            </span>
                            <span className="flex-1 font-medium">{item.label}</span>
                            <ChevronDown
                              className={cn(
                                "w-4 h-4 transition-transform",
                                isActive ? "text-blue-600" : "text-gray-400"
                              )}
                            />
                          </a>
                        </li>
                      );
                    })}

                    <li className="pt-2">
                      <a
                        href="#contact"
                        onClick={() => setMenuOpen(false)}
                        className={cn(
                          "relative block rounded-2xl overflow-hidden text-center",
                          "px-5 py-3.5 font-medium text-white",
                          "bg-gradient-to-r from-blue-600 to-emerald-500",
                          "shadow-[6px_6px_12px_#b8bcc2,-6px_-6px_12px_#ffffff]",
                          "active:shadow-[inset_4px_4px_8px_rgba(0,0,0,0.2)]"
                        )}
                      >
                        <span className="relative z-10 flex items-center justify-center gap-2">
                          Start Your Project
                          <Rocket className="w-4 h-4" />
                        </span>
                      </a>
                    </li>
                  </ul>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </motion.nav>

      {/* spacer so content doesn't hide under fixed navbar */}
      <div className="h-24" />

      {/* keyframes for gradient text */}
      <style jsx global>{`
        @keyframes gradient {
          0% {
            background-position: 0% 50%;
          }
          50% {
            background-position: 100% 50%;
          }
          100% {
            background-position: 0% 50%;
          }
        }
        .animate-gradient {
          animation: gradient 3s ease infinite;
        }
      `}</style>
    </>
  );
};